import React from "react";
import MensageriaLogFormPageContainer from "./MensageriaLogFormPageContainer";

export class MensageriaLogFormPage extends React.Component {
  render() {
    return <MensageriaLogFormPageContainer {...this.props} />;
  }
}
